import React from 'react';
import { Link } from 'react-router-dom';

import { AnalyticsView } from '@copilot/ui';
import Loader from '../components/common/Loader';
import { LANGUAGES } from '../constants/languages';
import * as meetingApi from '../services/meetingApi';

const api = { getAnalytics: (rangeDays) => meetingApi.getAnalytics({ rangeDays }) };

const renderLink = ({ href, className, children }) => (
  <Link to={href} className={className}>
    {children}
  </Link>
);

// Analytics - @copilot/ui's AnalyticsView, shared with Desktop, wired to
// Web's API and routes.
function AnalyticsPage() {
  return (
    <AnalyticsView
      api={api}
      languages={LANGUAGES}
      meetingsHref="/app/history"
      startMeetingHref="/app/meeting/new"
      renderLink={renderLink}
      loadingIndicator={<Loader label="Loading analytics..." />}
    />
  );
}

export default AnalyticsPage;
